import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { KeycloakInitService } from '../auth-services/keycloak-init.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private readonly keycloakInitService: KeycloakInitService
  ) {
    super(router, keycloak)
  }

  async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri
          : window.location.origin + state.url,
      });
      return false;
    }

    const isAllowed = await this.keycloakInitService.canAccessRoute(state.url);
    if (isAllowed) {
      return true;
    }

    return this.router.parseUrl('/access-denied');
  }
}